import RatesInformations from 'parog-web/components/rates-informations';
import Button from 'ui-kit/components/button';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type DmpContext from 'parog-web/contexts/abstract/dmp-context';
import { on } from '@ember/modifier';

const RateExceeded = <template>
  <div class='ui negative icon message' data-test-message='error'>
    <i class='times icon'></i>
    <div class='content'>
      <div class='header'>
        Vous avez dépassé le nombre d'actualisations de parcours autorisées.
      </div>
      <div data-test-hourly-rate-exceeded>{{@context.dmpAdapter.LIMIT_PER_HOUR}}
        actualisations autorisées par heure :
        {{@context.dmpAdapter.currentHourlyRate}}
        actualisés sur la dernière heure
        {{#if @context.dmpAdapter.hasExceededHourlyRate}}<i
            class='times icon'
            data-test-hourly-rate-exceeded-icon
          ></i>{{/if}}</div>
      <div data-test-daily-rate-exceeded>
        {{@context.dmpAdapter.LIMIT_PER_DAY}}
        actualisations autorisées par jour :
        {{@context.dmpAdapter.currentDailyRate}}
        actualisés sur la journée
        {{#if @context.dmpAdapter.hasExceededDailyRate}}<i
            class='times icon'
            data-test-daily-rate-exceeded-icon
          ></i>{{/if}}
      </div>
      <RatesInformations @dmpAdapter={{@context.dmpAdapter}} />
    </div>
  </div>

  <Button type='button' class='ui fluid form-button' {{on 'click' @onDismiss}}>
    {{#if @dismissText}} {{@dismissText}} {{else}} Fermer {{/if}}
  </Button>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    context: DmpContext;
    onDismiss: () => void;
    dismissText?: string;
  };
}>;
export default RateExceeded;
